export const getLoginModalVisible = (state) => state.auth.showLoginModal;

export const getLoginReason = (state) =>state.auth.reason;
